import React from 'react';

const get_final_grade_pct = (final_grade) => {
    var rawmax=final_grade.rawGradeMax
    var earned=final_grade.finalGrade
    //console.log (rawmax)
    //console.log (earned)
    if(rawmax == 0){
        rawmax = 1
    }
    var pct = earned / rawmax;
    pct *= 100;
    pct = Math.round(pct * 100) / 100;
    //console.log(pct)
    return pct
}

export {get_final_grade_pct};